import { render, staticRenderFns } from "./formattedPreviewImage.vue?vue&type=template&id=0ba128cc"
import script from "./formattedPreviewImage.vue?vue&type=script&lang=js"
export * from "./formattedPreviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports